import * as actions from './Constants';

export const apiGet = (url, body = null) => api(url, 'GET', body);
export const apiPost = (url, body) => api(url, 'POST', body);
export const apiPostAndThen = (url, body, onSuccess) => api(url, 'POST', body, onSuccess);
export const apiPut = (url, body) => api(url, 'PUT', body);
export const apiDelete = (url) => api(url, 'DELETE');
export const apiDeleteAndThen = (url, onSuccess) => api(url, 'DELETE', null, onSuccess);
export const apiDeleteWithBodyAndThen = (url, body, onSuccess) => api(url, 'DELETE', body, onSuccess);



export class Methods {
    static delete = 'DELETE';
    static get = 'GET';
    static post = 'POST';
    static put = 'PUT';
}

export const apiRequest = (url, method, body, dispatch) =>
    fetch(url,
        {
            method: method || Methods.get,
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: body && JSON.stringify(body)
        })
        .then(res => {
            if (!res.ok) {
                res.json().then(err => {
                    throw new Error(JSON.stringify({ status: res.status, statusText: res.statusText, ...err }))
                }).catch(error => handleException(dispatch, error));
            }
            else {
                return res.status === 204 ? null : res.json();
            }
        }).catch(error => handleException(dispatch, error));



const handleException = (dispatch, error) => {
    try {
        dispatch && dispatch({
            type: actions.ERROR,
            payload: JSON.parse(error.message)
        });
        console.log(error.message);
    }
    catch {
        dispatch && dispatch({
            type: actions.ERROR,
            payload: { message: error ? error.message : 'Unable to send request.', status: 500, statusText: 'Error' }
        });
    }
}


const api = (url, method, body, onSuccess) =>
    fetch(url,
        {
            method,
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            credentials: 'include',
            body: body && JSON.stringify(body)
        })
        .then(res => {
            if (!res.ok) {
                return res.json().then(err => {
                    throw new Error(JSON.stringify({ status: res.status, statusText: res.statusText, ...err }))
                });
            }
            else {
                return onSuccess ? onSuccess().then(x => x) : res.json();
            }
        });

export const fetchReport = (url, body) =>
    fetch(
        process.env.REACT_APP_API_HOST + `api/${url}`,
        {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: body && JSON.stringify(body),
            responseType: 'blob'
        })
        .then(res => res.blob())
        .then(data => {
            //Build a URL from the file
            const fileURL = URL.createObjectURL(data);
            //Open the URL on new Window
            window.open(fileURL);
        });